import { render, staticRenderFns } from "./OurBeliefsTechnologySection.vue?vue&type=template&id=7f054d88"
import script from "./OurBeliefsTechnologySection.vue?vue&type=script&lang=ts"
export * from "./OurBeliefsTechnologySection.vue?vue&type=script&lang=ts"
import style0 from "./OurBeliefsTechnologySection.vue?vue&type=style&index=0&id=7f054d88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports